// ======================================================================
// File Name       : PathConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const LOGIN = '/login';
export const ROUTE_LOGIN = 'login'; // Step9.0.0
export const CHANGE_PASSWORD = '/changePassword';

export const SERVICE_LOGIN = 'serviceLogin';
export const SERVICE_LOGIN_LIST = '/serviceLogin';

export const TOP = 'top';
export const TOP_LIST = '/top';

export const NOTICE = 'notice';
export const ENTERPRISE_NOTIFICATION = 'noticeForEnterprise';
export const ENTERPRISE_NOTIFICATION_LIST = '/notice/noticeForEnterprise/top';
export const ENTERPRISE_NOTIFICATION_IMPORT = '/notice/noticeForEnterprise/import';
export const ENTERPRISE_NOTIFICATION_REGISTER = '/notice/noticeForEnterprise/register';
export const ENTERPRISE_NOTIFICATION_DETAIL = '/notice/noticeForEnterprise/:id';
export const ENTERPRISE_NOTIFICATION_EDIT = '/notice/noticeForEnterprise/:id/edit';

export const ENTERPRISE = 'enterprise';
export const ENTERPRISE_LIST = '/enterprise/top';
export const ENTERPRISE_IMPORT = '/enterprise/import';

export const SUPERUSER = 'superuser';
export const SUPERUSER_LIST = '/superuser/top';
export const SUPERUSER_DETAIL = '/superuser/:id';
export const SUPERUSER_EDIT = '/superuser/:id/edit';
export const SUPERUSER_REGISTER = '/superuser/register';
export const SUPERUSER_IMPORT = '/superuser/import';

export const SERVICE = 'service';
export const SERVICE_LIST = '/service/top';
export const SERVICE_DETAIL = '/service/detail/:id';
export const SERVICE_EDIT = '/service/:id/edit';
export const SERVICE_REGISTER = '/service/register';
export const SERVICE_IMPORT = '/service/import';
export const SERVICE_MENU_NONE = '/service/detail-menunone';
export const SERVICE_DETAIL_MENU_NONE = '/service/detail-menunone/:id';

export const AUTHORITY = 'authority';
export const AUTHORITY_LIST = '/authority/top';
export const AUTHORITY_DETAIL = '/authority/:id';
export const AUTHORITY_EDIT = '/authority/:id/edit';
export const AUTHORITY_REGISTER = '/authority/register';
export const AUTHORITY_IMPORT = '/authority/import';

export const USER = 'user';
export const USER_LIST = '/user/top';
export const USER_DETAIL = '/user/:id';
export const USER_EDIT = '/user/:id/edit';
export const USER_REGISTER = '/user/register';
export const USER_IMPORT = '/user/import';

export const GROUP = 'group';
export const GROUP_LIST = '/group/top';
export const GROUP_IMPORT = '/group/import';

export const CONTENT_DISTRIBUTION = 'contentDistribution';
export const CONTENT_DISTRIBUTION_LIST = '/contentDistribution/top';
export const CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL = '/contentDistribution/offerList/:id';
export const CONTENT_DISTRIBUTION_OFFER_LIST_EDIT = '/contentDistribution/offerList/:id/edit';
export const CONTENT_DISTRIBUTION_REGISTER = '/contentDistribution/register';
export const CONTENT_DISTRIBUTION_IMPORT = '/contentDistribution/import';
export const COURSE_DISTRIBUTION_IMPORT = '/contentDistribution/courseImport';
export const CONTENT_DISTRIBUTION_USAGE_DETAIL = '/contentDistribution/usageDetail/:id';

export const EXTERNAL_CONTENT = 'externalContent';
export const EXTERNAL_CONTENT_LIST = '/externalContent';

export const COURSE = 'course';
export const COURSE_LIST = '/course/top';
export const COURSE_IMPORT = '/course/import';
export const COURSE_THUMBNAIL_UPDATE = '/course/defaultthumbnail';

export const CONTENT = 'content';
export const CONTENT_LIST = '/content/top';
export const PREVIEW_EACH_QUESTION_ATTRIBUTE = '/content/eachQuestionAttribute/preview';

export const CONTENT_DRILL = 'drill';
export const CONTENT_DRILL_LIST = '/content/drill/top';
export const CONTENT_DRILL_REGISTER = '/content/drill/register';
export const CONTENT_DRILL_IMPORT = '/content/drill/import';
export const CONTENT_DRILL_EDIT = '/content/drill/:id/edit';
export const CONTENT_DRILL_DETAIL = '/content/drill/:id';

// content drill skin
export const CONTENT_DRILL_SKIN = 'drillSkin';
export const CONTENT_DRILL_SKIN_LIST = '/content/drillSkin/top';
export const CONTENT_DRILL_SKIN_REGISTER = '/content/drillSkin/register';
export const CONTENT_DRILL_SKIN_DETAIL = '/content/drillSkin/:id';
export const CONTENT_DRILL_SKIN_EDIT = '/content/drillSkin/:id/edit';

export const CONTENT_QUESTION = 'question';
export const CONTENT_QUESTION_LIST = '/content/question/top';
export const CONTENT_QUESTION_REGISTER = '/content/question/register';
export const CONTENT_QUESTION_ATTRIBUTE = '/content/question/attribute';
export const CONTENT_QUESTION_ATTRIBUTE_LIST = '/content/question/attribute/top';
export const CONTENT_QUESTION_IMPORT = '/content/question/import';
export const CONTENT_QUESTION_DETAIL = '/content/question/:id';
export const CONTENT_QUESTION_DETAIL_PREVIEW = '/content/question/:id/preview';
export const CONTENT_QUESTION_EDIT = '/content/question/:id/edit';

export const CONTENT_VIDEO = 'video';
export const CONTENT_VIDEO_LIST = '/content/video/top';
export const CONTENT_VIDEO_REGISTER = '/content/video/register';
export const CONTENT_VIDEO_DETAIL = '/content/video/:id';
export const CONTENT_VIDEO_EDIT = '/content/video/:id/edit';
export const CONTENT_VIDEO_IMPORT = '/content/video/import';

export const CONTENT_DOCUMENT = 'document';
export const CONTENT_DOCUMENT_LIST = '/content/document/top';
export const CONTENT_DOCUMENT_REGISTER = '/content/document/register';
export const CONTENT_DOCUMENT_IMPORT = '/content/document/import';
export const CONTENT_DOCUMENT_DETAIL = '/content/document/:id';
export const CONTENT_DOCUMENT_EDIT = '/content/document/:id/edit';

export const CONTENT_LINK = 'link';
export const CONTENT_LINK_LIST = '/content/link/top';
export const CONTENT_LINK_REGISTER = '/content/link/register';
export const CONTENT_LINK_IMPORT = '/content/link/import';
export const CONTENT_LINK_DETAIL = '/content/link/:id';
export const CONTENT_LINK_EDIT = '/content/link/:id/edit';

export const CONTENT_DRILL_NOTIFICATION = 'notification';
export const CONTENT_DRILL_NOTIFICATION_LIST = '/content/notification/top';
export const CONTENT_DRILL_NOTIFICATION_REGISTER = '/content/notification/register';
export const CONTENT_DRILL_NOTIFICATION_EDIT = '/content/notification/:id/edit';
export const CONTENT_DRILL_NOTIFICATION_DETAIL = '/content/notification/:id';

export const SCORING = 'scoring';
export const SCORING_REPORT = '/scoring/report';
export const SCORING_REPORT_LIST = '/scoring/report/:mode';
export const SCORING_REPORT_TOP = '/scoring/report/top';
export const SCORING_REPORT_GET = '/scoring/report/get';
export const SCORING_REPORT_CORRECTION = '/scoring/report/correction'; // 添削
export const SCORING_REPORT_APPROVAL = '/scoring/report/approval'; // 承認
export const SCORING_REPORT_REMAND = '/scoring/report/remand'; // 差し戻し
export const SCORING_REPORT_COLLECTION = '/scoring/report/collection'; // 強制回収
export const SCORING_REPORT_WITHDRAWAL = '/scoring/report/withdrawal'; // 取り下げ
export const SCORING_DISTRIBUTION_REPORT = '/scoring/distribution'; // レポート分配
export const SCORING_RESULT_LIST = '/scoring/result'; // 添削者別実績一覧
export const SCORING_ARCHIVEMENT_LIST = '/scoring/archivement';
export const SCORING_ARCHIVEMENT_DETAIL = '/scoring/archivement/:id';
export const SCORING_UNSUBMITTED_LIST = '/scoring/unsubmitted';

export const ARCHIVEMENT = 'archivement';
export const ARCHIVEMENT_STUDENT_LIST = '/archivement/student';

export const NOTIFICATION = 'notification';

export const SERVICE_USAGE = 'serviceUsage';

// Service notification
export const SERVICE_NOTIFICATION = 'serviceNotification';
export const SERVICE_NOTIFICATION_LIST = '/notice/serviceNotification/top';
export const SERVICE_NOTIFICATION_DETAIL = '/notice/serviceNotification/:id';
export const SERVICE_NOTIFICATION_EDIT = '/notice/serviceNotification/:id/edit';
export const SERVICE_NOTIFICATION_REGISTER = '/notice/serviceNotification/register';
export const SERVICE_NOTIFICATION_IMPORT = '/notice/serviceNotification/import';

export const USER_HISTORY = 'userHistory';
export const COURSE_GRADES = 'courseGrades';
export const USER_HISTORY_STUDENT = '/userHistory/courseGrades/student';
export const USER_HISTORY_STUDENT_LIST = '/userHistory/courseGrades/student/top';
export const USER_HISTORY_STUDENT_DETAIL = '/userHistory/courseGrades/student/:id';
export const USER_HISTORY_STUDENT_RESULT = '/userHistory/courseGrades/result/:id';
export const USER_HISTORY_COURSE = '/userHistory/courseGrades/course';
export const USER_HISTORY_COURSE_LIST = '/userHistory/courseGrades/course/top';
export const USER_HISTORY_COURSE_DETAIL = '/userHistory/courseGrades/course/:id';
export const USER_HISTORY_COURSE_STUDENT_DETAIL = '/userHistory/courseGrades/course/student/:id';
export const USER_HISTORY_COURSE_STUDENT_RESULT = '/userHistory/courseGrades/course/result/:id';
export const USER_HISTORY_CONTENT = '/userHistory/courseGrades/content';
export const USER_HISTORY_CONTENT_LIST = '/userHistory/courseGrades/content/top';
export const USER_HISTORY_CONTENT_DETAIL = '/userHistory/courseGrades/content/:id';
// #7386 START
export const USER_HISTORY_AGGREGATE_BY_PROBLEM = '/userHistory/courseGrades/aggregateByProblem';
export const USER_HISTORY_AGGREGATE_BY_PROBLEM_DETAIL = '/userHistory/courseGrades/aggregateByProblem/:id';
// #7386 END
export const LIVE_HISTORY = 'liveHistory';
export const PARTICIPANT_LIST = '/userHistory/liveHistory/participant/top';
export const PARTICIPANT_DETAIL = '/userHistory/liveHistory/participant/:id';
export const USER_HISTORY_LIVE_PERFORMANCE_LIST = '/userHistory/liveHistory/livePerformance/top';
export const USER_HISTORY_LIVE_PERFORMANCE_DETAIL = '/userHistory/liveHistory/livePerformance/:id';
export const DOWNLOAD_CSV_FILE = 'csvDownload';
export const LEARNING_HISTORY_CSV_DOWNLOAD = '/userHistory/csvDownload/learningHistoryCSVDownload';
export const PROGRESS_STATUS_CSV_DOWNLOAD = '/userHistory/csvDownload/progressStatusCSVDownload';

export const LEARNING_AI = 'learningAI';
export const LEARNING_AI_IMPORT = '/learningAI/import';

export const ACCOUNT = 'account';
export const ACCOUNT_EDIT = '/account/edit';

export const REPORT = 'report';
export const REPORT_LIST = '/report/:mode';

export const SERVICE_RECORD = 'serviceRecord';
export const SERVICE_RECORD_COMPANY_LIST = '/serviceRecord/company';
export const SERVICE_RECORD_SERVICE_LIST = '/serviceRecord/service';
export const SERVICE_RECORD_DOWNLOAD_FORM = '/serviceRecord/download';
export const SERVICE_RECORD_SERVICES_LIST = '/serviceRecord/servicelist'; // Step 12.3.0 TAS-21359

// mesage thread

export const MESSAGE_THREAD = 'messageThread';
export const RECEIVED_MESSAGE_LIST = '/messageThread/received/top';
export const SENT_MESSAGE_LIST = '/messageThread/sent/top';
export const REGISTER_MESSAGE_THREAD = '/messageThread/register';
export const EDIT_MESSAGE_THREAD = '/messageThread/:id/edit';
export const RECEIVE_MESSAGE_THREAD_DETAIL = '/messageThread/received/:id';
export const RECEIVE_CHAT_DETAIL = '/messageThread/received/chat/:messageRootId/:userSecernId';
export const SENT_MESSAGE_THREAD_DETAIL = '/messageThread/sent/:id';
export const SENT_CHAT_DETAIL = '/messageThread/sent/chat/:messageRootId/:userSecernId';
// usage setting live
export const LIVE = 'live';
export const LIVE_RESERVED_LIST = '/live/resereved/top';
export const LIVE_RESERVED_DETAIL = '/live/resereved/:id';
export const LIVE_RESERVED_REGISTER = '/live/resereved/register';
export const LIVE_RESERVED_EDIT = '/live/resereved/:id/edit';

// adaptive
export const ADAPTIVE = 'adaptive';
export const ADAPTIVE_META = '/adaptive/meta';
export const DISCRIMINATION_DEGREE_DATA = '/adaptive/discriminationDegreeData';

// 画面用構成ファイル管
export const CONFIG_FILE = 'configFile';
export const DOWNLOAD_CONFIG_FILE = '/configFile/downloadConfigFile';
export const UPLOAD_CONFIG_FILE = '/configFile/uploadConfigFile';

// usage setting mail
export const EMAIL = 'email';
export const EMAIL_LIST = '/email/top';
export const EMAIL_REGISTER = '/email/register';
export const RESERVED_EMAIL_LIST = '/email/reserved/top';
export const RESERVED_EMAIL_DETAIL = '/email/reserved/:id';
export const RESERVED_EMAIL_EDIT = '/email/reserved/:id/edit';

// 多言語表示
export const MULTI_LANGUAGE = 'multiLanguage';
export const MULTI_LANGUAGE_LIST = '/multiLanguage/top';
export const MULTI_LANGUAGE_EDIT = '/multiLanguage/:id';
export const MULTI_LANGUAGE_PROCESS_RESULT_LIST = '/multiLanguage/process/top';
export const MULTI_LANGUAGE_PROCESS_DETAIL = '/multiLanguage/process/:id';

// 受講者画面管理
export const USERFRONT = 'userfront';
export const USERFRONT_LOGIN_SCREEN_UPDATE = '/userfront/loginScreenUpdate';
export const USERFRONT_TOP_SCREEN_UPDATE = '/userfront/topScreenUpdate';
export const USERFRONT_CERTIFICATE_COMPLETION = '/userfront/certificateCompletion'; // Step 11.0.0

// パスワードリセット
export const PASSWORD_RESET_REQUEST = '/password/reset/request';
export const SUPERUSER_PASSWORD_RESET_REQUEST = '/superuser/password/reset/request';
export const PASSWORD_RESET_REQUEST_COMPLETE = '/password/reset/request/complete';

// Path General for Content, Drill
export const GENERAL_CONTENT_VIDEO = '/content/video';
export const GENERAL_CONTENT_DOCUMENT = '/content/document';
export const GENERAL_CONTENT_LINK = '/content/link';
export const GENERAL_CONTENT_MULTILANGUAGE = '/multiLanguage';

export const GENERAL_CONTENT_DRILL = '/content/drill';
export const GENERAL_CONTENT_SKIN = '/content/drillSkin';
export const GENERAL_CONTENT_QUESTION = '/content/question';

// Step 10.0.0 START
// サービスグループ設定
export const SERVICE_GROUP = 'serviceGroup';
export const SERVICE_GROUP_LIST = '/serviceGroup/top';
export const SERVICE_GROUP_DETAIL = '/serviceGroup/:id';
export const SERVICE_GROUP_EDIT = '/serviceGroup/:id/edit';
export const SERVICE_GROUP_REGISTER = '/serviceGroup/register';

// SuperUserサービスロール設定
export const SUPERUSER_SERVICE_ROLE = 'superuserServiceRole';
export const SUPERUSER_SERVICE_ROLE_LIST = '/superuserServiceRole/top';
export const SUPERUSER_SERVICE_ROLE_DETAIL = '/superuserServiceRole/:id';
export const SUPERUSER_SERVICE_ROLE_EDIT = '/superuserServiceRole/:id/edit';
export const SUPERUSER_SERVICE_ROLE_REGISTER = '/superuserServiceRole/register';

// SuperUser企業ロール設定
export const SUPERUSER_ENTERPRISE_ROLE = 'superuserEnterpriseRole';
export const SUPERUSER_ENTERPRISE_ROLE_LIST = '/superuserEnterpriseRole/top';
export const SUPERUSER_ENTERPRISE_ROLE_DETAIL = '/superuserEnterpriseRole/:id';
export const SUPERUSER_ENTERPRISE_ROLE_EDIT = '/superuserEnterpriseRole/:id/edit';
export const SUPERUSER_ENTERPRISE_ROLE_REGISTER = '/superuserEnterpriseRole/register';

// ログイン履歴ダウンロード
export const LOGIN_HISTORY = 'loginHistory';
export const LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD = '/loginHistory/enterprise/loginHistoryCSVDownload';
export const LOGIN_HISTORY_SERVICE_CSV_DOWNLOAD = '/loginHistory/service/loginHistoryCSVDownload';
// Step 10.0.0 END

// Step 12.0.0 START
// 企業切り替え
export const ENTERPRISE_SWITCHING = 'enterpriseSwitching';
// コンテンツグループ
export const CONTENT_GROUP = 'contentGroup';
// メールテンプレート設定
export const MAIL_TEMPLATE_USERS = 'mailTemplateUsers';
// Step 12.0.0 END
